var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 19.5V10.808C5 10.552 5.05733 10.3097 5.172 10.081C5.28667 9.85232 5.44467 9.66399 5.646 9.51599L11.031 5.43799C11.313 5.22266 11.635 5.11499 11.997 5.11499C12.359 5.11499 12.683 5.22266 12.969 5.43799L18.354 9.51499C18.556 9.66299 18.714 9.85166 18.828 10.081C18.9427 10.3097 19 10.552 19 10.808V19.5C19 19.768 18.9003 20.0017 18.701 20.201C18.5017 20.4003 18.268 20.5 18 20.5H14.616C14.3867 20.5 14.1947 20.4227 14.04 20.268C13.8853 20.1127 13.808 19.9207 13.808 19.692V14.923C13.808 14.6943 13.7307 14.5027 13.576 14.348C13.4207 14.1927 13.2287 14.115 13 14.115H11C10.7713 14.115 10.5797 14.1927 10.425 14.348C10.2697 14.5027 10.192 14.6943 10.192 14.923V19.693C10.192 19.9217 10.1147 20.1133 9.96 20.268C9.80533 20.4227 9.61367 20.5 9.385 20.5H6C5.732 20.5 5.49833 20.4003 5.299 20.201C5.09967 20.0017 5 19.768 5 19.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.d44ae9bdfbdd9cef4503242f30cefd00.svg";
export { ForwardRef as ReactComponent };